import React, { useState, useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

export const DateInput = React.forwardRef(
    ({ changeEvent, onChange, value, onBlur, title, id, required, validState, disabled, ...props }, ref) => {
        const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
        const actualChangeEvent = changeEvent == null ? onChange : changeEvent;

        const maskedValue = useMemo(() => {            
            if (value) {
                let date = value;
                if (typeof value === "string") {
                    const newValue = value.replace("Z", "");
                    date = moment(newValue).toDate();
                    // date = new Date(value);
                }
    
                var dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
                return dateWithoutTime;
            }
        }, [value])
        
        return (
            <div
                className={`input-field ${value && value.length > 0 && "has-data"} ${disabled &&
                    "disabled"} validation-container ${validState}`}
            >
                <div className={ disabled ? "disabled" : ""}>
                    <label htmlFor={id} className={`input-field__label ${required && "required"} `}>
                        {title}
                    </label>
                    <DatePicker
                        selected={maskedValue}
                        onChange={date => {
                            const year = date.getFullYear();
                            const month = date.getMonth();
                            const day = date.getDate();
                            const newDate = new Date(year, month, day, 0, 0, 0);
                            const dateString = moment(newDate).format("MM/DD/YYYY")
                            actualChangeEvent(dateString);
                        }}
                        onSelect={date => {
                            const dateString = moment(date).format("MM/DD/YYYY")
                            actualChangeEvent(dateString);
                        }}
                        placeholderText={"MM/DD/YYYY"}
                        onBlur={onBlur}
                        id={id}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        name={props.name}
                        disabled={disabled}
                        className={"input-field__input validation-input"}
                        customInput={
                            <MaskedInput
                                pipe={autoCorrectedDatePipe}
                                mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
                                keepCharPositions={true}
                                guide={true}
                            />
                        }
                        autoComplete='off' 
                        
                    />
                    {validState === "invalid" ? <span className="validation-message">{props.errorMessage}</span> : null}
                </div>
            </div>
        );
    }
);
